<script>
    import {_} from 'svelte-i18n';
    import PackListing from '../PackListing.svelte';
    import {onMount} from 'svelte';
    import {goTo} from "../../utils.js";

    onMount(() => {
        window.scrollTo(0, 0);
        goTo('/supplies/customizablePacks', true);
    });
</script>

<PackListing storeSection="customizablePacks" title={$_('NewShopTabCustomizablePacks')}/>
